import React, { Component, createRef } from "react";
import {
  POST,
  loading,
  token,
  alert,
  tokens,
  locale,
  params,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BG from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_customer: [],
    };
  }
  componentDidMount = async () => {
    loading(false);
    this.Get();
  };
  Get = async () => {
    loading(true);
    let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
      let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
      result = await response.json();
      localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    } else {
      result = tokens;
    }
    this.setState({
      data_customer: result?.customer ? Object.values(result?.customer) : [],
    });
    loading(false);
  };
  render() {
    const { data_customer } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />
        {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../assets/images/bg-2.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 400,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">ลูกค้า</h1>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 bg-gray align-content-center">
          <div className="row container mx-auto my-5 justify-content-center">
            {data_customer
              ?.filter(
                (e) =>
                  !params("filter") ||
                  e.th_sector === params("filter") ||
                  params("filter") === "ทั้งหมด"
              )
              .map((item, index) => (
                <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-2 px-1 product pointer">
                  <div className="card card-dashboard p-2 bg-white rounded-3 border-0 shadow-sm mb-2">
                      <img
                        alt="THUMBNAIL"
                        src={item.photo || BG}
                        className="hpx-200 w-100 rounded-3 mb-3 bg-promary-light"
                        style={{ objectFit: "contain" }}
                      />
                  </div>

                      <h6 className="fw-bold">
                        {item[`${locale}_name`] || item.th_name}
                      </h6>
                      <div className="mb-2 text-secondary text-14">
                        {item[`${locale}_address`] || item.th_address}
                      </div>
                </div>
              ))}
          </div>
        </div>
        <div className="hpx-40"></div>
        <Footer />
      </div>
    );
  }
}
